import React from 'react';
import {path} from './Constant';
import {seo} from './Seo';
class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.data.result.languages,
            //selected_flag:'en',
            selected_flag:window.sessionStorage.getItem('language'),
            villa:props.villa
        }
        
    }

    componentDidMount = () => {
        seo({
            title: this.props.data.result.villa.name,
            metaDescription: this.props.data.result.welcome.moment_text
        });
    }

    /**
     * 
     */
    _getLanguageDropdown = () => {
        return (
            this.state.data.map((value, index) => {
                if(value !== this.state.selected_flag){
                    return (
                        <button className="dropdown-item" onClick={()=>{this._handleFlagClick(value)}} key={index}><img src={path+"images/flags/" + value + ".svg"} alt={value} className="d-block mx-auto" /></button>
                    )
                }
            })
        )

    }

    _handleFlagClick=(lang)=>{
        this.setState({
            selected_flag:lang
        })
        this.props.handleLanguageChange(lang);
    }

    render() {

        return (
            <React.Fragment>
                <header className="headerSection">
                    <nav className="navbar navbar-expand-md bg-dark navbar-dark fixed-top">
                        <div className="container">
                            <a href="#" className="navbar-brand d-block d-md-none"><img src={path+"/images/logo2.png"} alt="Club Miracle" className="mx-auto d-block img-fluid" /></a>
                            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
                                <ul className="navbar-nav ml-auto mt-2 mt-lg-0">
                                    <li className="nav-item">
                                        <a className="nav-link" href={"/villa/why-us/"+this.state.villa}>{this.props.data.result.static_text.why_us_text+' ?'}{/**this.props.data.result.static_text.maintenance_text**/}</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href={"/villa/concierge/"+this.state.villa}>{this.props.data.result.static_text.concierge_text}</a>
                                    </li>
                                </ul>

                                <div className="mx-auto d-none d-md-block">
                                    <a href={typeof this.props.data.result.villa.logo_link !="undefined" && this.props.data.result.villa.logo_link !=null?this.props.data.result.villa.logo_link:"/villa/"+this.state.villa} className="navbar-brand"><img src={typeof this.props.data.result.villa.logo !="undefined" && this.props.data.result.villa.logo !=null?this.props.data.result.villa.logo :path+"images/logo.jpg"} alt="Club Miracle" className="mx-auto d-block img-fluid" /></a>
                                </div>

                                <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
                                    <li className="nav-item">
                                        <a className="nav-link" href={"/villa/destination/"+this.state.villa}>
                                            {typeof this.props.data.result.villa.district !="undefined" && this.props.data.result.villa.district !=null?this.props.data.result.villa.district : this.props.data.result.static_text.destinations_text}</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href={"/villa/talk-to-us/"+this.state.villa}>{this.props.data.result.static_text.talk_to_us_text}</a>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
                                            <img src={path+"images/flags/"+this.state.selected_flag+'.svg'} alt="United Kingdom" className="d-block img-fluid" />
                                        </a>
                                        <div className="dropdown-menu" style={{"zIndex":9999}}>
                                            {this._getLanguageDropdown()}

                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </header>

            </React.Fragment>
        );
    }
}

export default Header;